











import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import loader from "@/components/loader.vue";
import billingApi from "@/services/billing";
import { Mutation } from "vuex-class";

@Component({
  components: {
    loader
  }
})
export default class ResendEmail extends Vue {
  @Prop() public value: any;
  @Mutation("setLastErr") public setLastErr: any;

  private sent = false;
  private sending = false;

  private async resend() {
    if (this.sent) {
      return;
    }

    this.sending = true;
    let res = "";
    try {
      res = await billingApi.resendEmail(this.value.id);
    } catch (err) {
      this.setLastErr(err);
      this.sending = false;
    }
    this.sending = false;

    this.sent = res === "ok";
  }
}
